/*
  De reviewcarrousel.

  Drie kaarten tegelijk op een breed scherm, één op een telefoon. Het schuiven
  gebeurt met scroll-snap in plaats van met een berekende transform: dan werkt
  vegen op een telefoon vanzelf, en hoeft er niets herrekend te worden als het
  venster van maat verandert.

  De pijltjes schuiven precies één beeld op. Aan het begin en het eind zijn ze
  uitgeschakeld, zodat er geen knop staat die niets doet.
*/
(function () {
  'use strict';

  function start(wortel) {
    var spoor = wortel.querySelector('[data-tprail]');
    if (!spoor) return;

    var terug = wortel.querySelector('[data-tpterug]');
    var verder = wortel.querySelector('[data-tpverder]');
    if (!terug || !verder) return;

    var bezig = false;

    function stand() {
      /*
        Een pixel speling: browsers rekenen de scrollbreedte soms op een
        fractie na af, en dan blijft de knop eeuwig aan staan.
      */
      var links = spoor.scrollLeft;
      var rest = spoor.scrollWidth - spoor.clientWidth - links;
      terug.disabled = links <= 1;
      verder.disabled = rest <= 1;
    }

    function schuif(richting) {
      spoor.scrollBy({
        left: richting * spoor.clientWidth,
        behavior: 'smooth'
      });
    }

    terug.addEventListener('click', function () { schuif(-1); });
    verder.addEventListener('click', function () { schuif(1); });

    spoor.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      window.requestAnimationFrame(function () {
        stand();
        bezig = false;
      });
    });

    window.addEventListener('resize', stand);
    stand();
  }

  /*
    De knop 'Lees meer' hoort alleen te staan als er iets is afgeknipt. Of dat
    zo is weet alleen de browser: hij vergelijkt de hoogte van de hele tekst
    met die van het ingekorte vak.
  */
  function inkorten(wortel) {
    var kaarten = wortel.querySelectorAll('.tprev');

    for (var i = 0; i < kaarten.length; i++) {
      (function (kaart) {
        var tekst = kaart.querySelector('[data-tptekst]');
        var knop = kaart.querySelector('[data-tpmeer]');
        if (!tekst || !knop) return;

        function meten() {
          if (kaart.classList.contains('is-open')) return;
          knop.hidden = tekst.scrollHeight <= tekst.clientHeight + 1;
        }

        knop.addEventListener('click', function () {
          var open = kaart.classList.toggle('is-open');
          knop.textContent = open
            ? (knop.getAttribute('data-minder') || 'Lees minder')
            : (knop.getAttribute('data-meer') || 'Lees meer');
          if (!open) meten();
        });

        window.addEventListener('resize', meten);
        meten();
        window.addEventListener('load', meten);
      })(kaarten[i]);
    }
  }

  function alles(wortel) {
    inkorten(wortel || document);
    var vlakken = (wortel || document).querySelectorAll('[data-tpcarrousel]');
    for (var i = 0; i < vlakken.length; i++) start(vlakken[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alles(); });
  } else {
    alles();
  }

  /* In de theme editor wordt een sectie opnieuw ingevoegd zonder herladen. */
  document.addEventListener('shopify:section:load', function (e) { alles(e.target); });
})();
